import { ROUTE_SIGN_IN_VERIFY_OTP } from '@/constants/routes';
import { TOAST_DEFAULT_OPTIONS } from '@/constants/toast';
import { Urls } from '@/constants/urls';
import useAnalyticsCalls from '@/hooks/use-analytics';
import { useSignInMutation } from '@/queries/auth.queries';
import { useToast } from '@cmpsr/components';
import { AxiosError } from 'axios';
import { useForm } from 'react-hook-form';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function useEnterEmailController() {
  const signInMutation = useSignInMutation();
  const navigate = useNavigate();
  const analytics = useAnalyticsCalls();
  const [searchParams] = useSearchParams();
  const emailFromUrl = searchParams.get('email') || '';
  const form = useForm({ mode: 'onSubmit', reValidateMode: 'onChange', defaultValues: { email: emailFromUrl } });
  const toast = useToast();

  const handleBack = () => {
    window.location.href = Urls.homepage;
    return;
  };

  const handleSubmit = form.handleSubmit((values) => {
    analytics.callSignInStarted();
    signInMutation
      .mutateAsync({ credential: values.email, credentialType: 'email' })
      .then((res) => {
        const params = new URLSearchParams();
        params.append('id', res.id);
        params.append('type', res.type);
        params.append('email', values.email);
        return navigate({ pathname: ROUTE_SIGN_IN_VERIFY_OTP, search: params.toString() });
      })
      .catch((error) => {
        if (error instanceof AxiosError && error.response?.status === 400) {
          form.setError('email', {
            type: 'server',
            message: 'Account does not yet exist, please click on Get started',
          });
        } else {
          console.error(error);
          toast({
            ...TOAST_DEFAULT_OPTIONS,
            title: `Error ${error.response?.data?.statusCode ?? ''}`,
            description: error.response?.data?.message ?? error.message,
            status: 'error',
          });
        }
      });
  });

  return {
    form,
    handleSubmit,
    handleBack,
  };
}
